<template>
    <HXContentCard title="Listado de Puntos de Entrega y Rutas">
        <!-- Pantalla de carga -->
        <transition name="fade">
            <div v-if="loading" class="text-center">
                <div class="">
                    <div class="emoji-container">
                        <span class="emoji" role="img" aria-label="Truck">🚚</span>
                        <span class="emoji" role="img" aria-label="Hourglass">⏳</span>
                        <span class="emoji" role="img" aria-label="Map">🗺️</span>
                    </div>
                    <span class="h2 font-weight-bold">Cargando datos...</span>
                    <p class="loading-message">Espere un momento mientras preparamos la información.</p>
                </div>
            </div>
        </transition>

        <!-- Contenido principal -->
        <div v-if="!loading">
            <!-- Filtros de fecha -->
            <div class="px-4 mt-3 mb-4">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="fechaInicio">Fecha de inicio:</label>
                            <input type="date" id="fechaInicio" class="form-control" v-model="filtros.fechaInicio">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="fechaFin">Fecha de fin (opcional):</label>
                            <input type="date" id="fechaFin" class="form-control" v-model="filtros.fechaFin">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="busqueda">Búsqueda:</label>
                            <div class="input-group">
                                <input type="text" id="busqueda" class="form-control"
                                    placeholder="Buscar en todos los campos..." v-model="filtros.busqueda"
                                    @input="aplicarBusqueda">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" @click="limpiarBusqueda">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 d-flex align-items-end">
                        <button class="btn btn-primary w-100" @click="buscarPuntosEntrega">
                            <i class="fas fa-search mr-2"></i> Buscar
                        </button>
                    </div>
                </div>

                <!-- Filtros avanzados -->
                <div class="row mt-2">
                    <div class="col-12">
                        <button class="btn btn-sm btn-outline-secondary"
                            @click="mostrarFiltrosAvanzados = !mostrarFiltrosAvanzados">
                            <i class="fas" :class="mostrarFiltrosAvanzados ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            {{ mostrarFiltrosAvanzados ? 'Ocultar filtros avanzados' : 'Mostrar filtros avanzados' }}
                        </button>
                    </div>
                </div>

                <transition name="fade">
                    <div class="row mt-3" v-if="mostrarFiltrosAvanzados">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="filtroEstadoPunto">Estado Punto Entrega:</label>
                                <select id="filtroEstadoPunto" class="form-control" v-model="filtros.estadoPuntoEntrega"
                                    @change="aplicarFiltrosAvanzados">
                                    <option value="">Todos</option>
                                    <option value="No ha iniciado">No ha iniciado</option>
                                    <option value="En proceso">En proceso</option>
                                    <option value="Completado">Completado</option>
                                    <option value="Cancelado">Cancelado</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="filtroEstadoRuta">Estado Ruta:</label>
                                <select id="filtroEstadoRuta" class="form-control" v-model="filtros.estadoRuta"
                                    @change="aplicarFiltrosAvanzados">
                                    <option value="">Todos</option>
                                    <option value="Pendiente">Pendiente</option>
                                    <option value="Iniciada">Iniciada</option>
                                    <option value="Finalizada">Finalizada</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="filtroCentroCosto">Centro de Costo:</label>
                                <input type="text" id="filtroCentroCosto" class="form-control"
                                    v-model="filtros.centroCosto" @input="aplicarFiltrosAvanzados">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="filtroCliente">Cliente:</label>
                                <input type="text" id="filtroCliente" class="form-control" v-model="filtros.cliente"
                                    @input="aplicarFiltrosAvanzados">
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

            <!-- Tarjetas de Resumen -->
            <div class="px-4 mt-3">
                <CardTable :data="dataCards" />
            </div>
            <exportExcel v-if="listaPuntosEntrega.length > 0" :headers="exportarRemisiones"
                :items="listaPuntosEntrega" />

            <!-- Tabla de Puntos de Entrega -->
            <div class="px-4 mt-3">
                <div class="table-responsive">
                    <div class="mb-3 d-flex justify-content-between align-items-center">
                        <div>
                            <span class="mr-2">Mostrar</span>
                            <select v-model="paginacion.registrosPorPagina"
                                class="form-control form-control-sm d-inline-block" style="width: auto"
                                @change="cambiarRegistrosPorPagina">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            <span class="ml-2">registros</span>
                        </div>
                        <div>
                            <span>Mostrando {{ paginacion.totalFiltrados }} de {{ listaPuntosEntrega.length }}
                                registros</span>
                        </div>
                    </div>
                    <table id="datatable_puntosEntrega"
                        class="table table-bordered table-responsive-md table-striped text-center">
                        <thead>
                            <tr>
                                <th>Fecha/Hora Inicio</th>
                                <th>Fecha/Hora Entrega</th>
                                <th>Fecha/Hora Fin</th>
                                <th>Centro de Costo</th>
                                <th>Nombre Ruta</th>
                                <th>Descripción Ruta</th>
                                <th>Número de Remisión</th>
                                <th>Nombre del Cliente</th>
                                <th>Dirección del Punto de Entrega</th>
                                <th>Nit</th>
                                <th>Persona Que recibió</th>
                                <th>Contacto Persona Que recibió</th>
                                <th>Placa</th>
                                <th>Conductor asignado</th>
                                <th>Estado Punto Entrega</th>
                                <th>Estado Ruta</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in listaPuntosEntregaFiltrados" :key="item.id" class="animated-row">
                                <td>{{ formatDateTime(item.fechaHoraInicio) }}</td>
                                <td>{{ formatDateTime(item.fechaHoraEntrega) }}</td>
                                <td>{{ formatDateTime(item.fechaHoraFin) }}</td>
                                <td>{{ item.lugarEntrega ? item.lugarEntrega : "No encontrado" }}</td>
                                <td>{{ item.nombreRuta ? item.nombreRuta : "No encontrado" }}</td>
                                <td>{{ item.descripcionRuta ? item.descripcionRuta : "No encontrado" }}</td>
                                <td>{{ item.numeroDocumentoEntrega ? item.numeroDocumentoEntrega : "No encontrado" }}
                                </td>
                                <td>{{ item.nombreCliente ? item.nombreCliente : "No encontrado" }}</td>
                                <td>{{ item.direccionPuntoEntrega ? item.direccionPuntoEntrega : "No encontrado" }}</td>
                                <td>{{ item.codigoSN ? item.codigoSN : "No encontrado" }}</td>
                                <td>{{ item.nombrePersonaCliente ? item.nombrePersonaCliente : "No encontrado" }}</td>
                                <td>{{ item.contactoPersonaCliente ? item.contactoPersonaCliente : "No encontrado" }}
                                </td>
                                <td>{{ item.placa ? item.placa : "No encontrado" }}</td>
                                <td>{{ item.nombreCompleto ? item.nombreCompleto : "No encontrado" }}</td>
                                <td>
                                    <span class="badge" :class="getBadgeClass(item.estadoPuntoEntrega)">
                                        {{ item.estadoPuntoEntrega }}
                                    </span>
                                </td>
                                <td>
                                    <span class="badge" :class="getBadgeClass(item.estadoRuta)">
                                        {{ item.estadoRuta }}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="listaPuntosEntregaFiltrados.length === 0">
                                <td colspan="15" class="text-center">No se encontraron registros que coincidan con los
                                    criterios de búsqueda</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Paginación -->
                    <div class="d-flex justify-content-between align-items-center mt-3">
                        <div>
                            <span>Página {{ paginacion.paginaActual }} de {{ paginacion.totalPaginas }}</span>
                        </div>
                        <div>
                            <nav aria-label="Navegación de páginas">
                                <ul class="pagination justify-content-end mb-0">
                                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === 1 }">
                                        <a class="page-link" href="#" @click.prevent="cambiarPagina(1)">
                                            <i class="fas fa-angle-double-left"></i>
                                        </a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: paginacion.paginaActual === 1 }">
                                        <a class="page-link" href="#"
                                            @click.prevent="cambiarPagina(paginacion.paginaActual - 1)">
                                            <i class="fas fa-angle-left"></i>
                                        </a>
                                    </li>
                                    <li v-for="pagina in paginasVisibles" :key="pagina" class="page-item"
                                        :class="{ active: pagina === paginacion.paginaActual }">
                                        <a class="page-link" href="#" @click.prevent="cambiarPagina(pagina)">{{ pagina
                                        }}</a>
                                    </li>
                                    <li class="page-item"
                                        :class="{ disabled: paginacion.paginaActual === paginacion.totalPaginas || paginacion.totalPaginas === 0 }">
                                        <a class="page-link" href="#"
                                            @click.prevent="cambiarPagina(paginacion.paginaActual + 1)">
                                            <i class="fas fa-angle-right"></i>
                                        </a>
                                    </li>
                                    <li class="page-item"
                                        :class="{ disabled: paginacion.paginaActual === paginacion.totalPaginas || paginacion.totalPaginas === 0 }">
                                        <a class="page-link" href="#"
                                            @click.prevent="cambiarPagina(paginacion.totalPaginas)">
                                            <i class="fas fa-angle-double-right"></i>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </HXContentCard>
</template>

<script>
import CardTable from "../../../components/cardTable/CardTable.vue";
import exportExcel from "../../../components/exportExcel/exportExcel.vue";

export default {
    name: "DashboardPuntosEntrega",
    components: {
        CardTable,
        exportExcel
    },
    data() {
        return {
            persona: null,
            listaPuntosEntrega: [],
            listaPuntosEntregaFiltrados: [],
            loading: false,
            error: null,
            dataTableInstance: null,
            mostrarFiltrosAvanzados: false,
            filtros: {
                fechaInicio: this.getFormattedDate(new Date()),
                fechaFin: null,
                busqueda: "",
                estadoPuntoEntrega: "",
                estadoRuta: "",
                centroCosto: "",
                cliente: ""
            },
            paginacion: {
                paginaActual: 1,
                registrosPorPagina: 10,
                totalPaginas: 0,
                totalFiltrados: 0
            },
            dataCards: [
                {
                    title: "Total de Puntos de Entrega",
                    value: () => this.listaPuntosEntrega.length,
                    iconName: "fas fa-map-marker-alt",
                    color: "rgba(254, 114, 28, 1)",
                    tipo: "squared",
                    animated: "bounce",
                },
                {
                    title: "Rutas Iniciadas",
                    value: () => this.listaPuntosEntrega.filter(item => item.estadoRuta === "Iniciada").length,
                    iconName: "fas fa-play-circle",
                    color: "rgba(22, 162, 117, 1)",
                    tipo: "squared",
                    animated: "bounce",
                },
                {
                    title: "Puntos No Iniciados",
                    value: () => this.listaPuntosEntrega.filter(item => item.estadoPuntoEntrega === "No ha iniciado").length,
                    iconName: "fas fa-hourglass-start",
                    color: "rgba(71, 136, 255, 1)",
                    tipo: "squared",
                    animated: "bounce",
                },
                {
                    title: "Puntos Completados",
                    value: () => this.listaPuntosEntrega.filter(item => item.estadoPuntoEntrega === "Completado").length,
                    iconName: "fas fa-check-circle",
                    color: "rgba(255, 193, 7, 1)",
                    tipo: "squared",
                    animated: "bounce",
                },
            ],

            exportarRemisiones: [
                { key: "numeroDocumentoEntrega", header: "Número Documento Entrega" },
                { key: "descripcionPuntoEntrega", header: "Descripción Punto Entrega" },
                { key: "nombreCliente", header: "Nombre Cliente" },
                { key: "direccionPuntoEntrega", header: "Dirección Punto Entrega" },
                { key: "codigoSN", header: "Código SN" },
                { key: "nombrePersonaCliente", header: "Nombre Persona Cliente" },
                { key: "contactoPersonaCliente", header: "Contacto Persona Cliente" },
                { key: "distanciaRecorrida", header: "Distancia Recorrida" },
                { key: "tiempoRecorrido", header: "Tiempo Recorrido" },
                { key: "fechaHoraInicio", header: "Fecha Hora Inicio" },
                { key: "fechaHoraEntrega", header: "Fecha Hora Entrega" },
                { key: "fechaHoraFin", header: "Fecha Hora Fin" },
                { key: "tiempoDescarga", header: "Tiempo Descarga" },
                { key: "estadoPuntoEntrega", header: "Estado Punto Entrega" },
                { key: "plantillaRutasId", header: "Plantilla Rutas ID" },
                { key: "puntosEntregaGeneralesId", header: "Puntos Entrega Generales ID" },
                { key: "lugarEntrega", header: "Lugar Entrega" },
                { key: "latUbicacionEntrega", header: "Lat Ubicacion Entrega" },
                { key: "longUbicacionEntrega", header: "Long Ubicacion Entrega" },
                { key: "fechaHoraInicioRuta", header: "Fecha Hora Inicio Ruta" },
                { key: "nombreRuta", header: "Nombre Ruta" },
                { key: "descripcionRuta", header: "Descripción Ruta" },
                { key: "placa", header: "Placa" },
                { key: "nombreCompleto", header: "Nombre Completo" },
                { key: "distanciaTotalRecorrida", header: "Distancia Total Recorrida" },
                { key: "tiempoTotalRecorrido", header: "Tiempo Total Recorrido" },
                { key: "estadoRuta", header: "Estado Ruta" }
            ],
        };
    },
    computed: {
        paginasVisibles() {
            const totalPaginas = this.paginacion.totalPaginas;
            const paginaActual = this.paginacion.paginaActual;

            if (totalPaginas <= 5) {
                return Array.from({ length: totalPaginas }, (_, i) => i + 1);
            }

            if (paginaActual <= 3) {
                return [1, 2, 3, 4, 5];
            }

            if (paginaActual >= totalPaginas - 2) {
                return [
                    totalPaginas - 4,
                    totalPaginas - 3,
                    totalPaginas - 2,
                    totalPaginas - 1,
                    totalPaginas
                ];
            }

            return [
                paginaActual - 2,
                paginaActual - 1,
                paginaActual,
                paginaActual + 1,
                paginaActual + 2
            ];
        }
    },
    watch: {
        'filtros.busqueda': function () {
            this.paginacion.paginaActual = 1;
            this.aplicarFiltros();
        }
    },
    async mounted() {
        try {
            const personaStr = localStorage.getItem("setPersonaAct");
            if (personaStr) {
                this.persona = JSON.parse(personaStr);
                await this.buscarPuntosEntrega();
            } else {
                console.log("No se encontró información de la persona en localStorage");
            }
        } catch (error) {
            console.error("Error al obtener la información de la persona:", error);
            console.log("Error al obtener la información de la persona");
        }
    },
    methods: {
        getFormattedDate(date) {
            return date.toISOString().split('T')[0];
        },

        formatDateForBackend(dateString) {
            if (!dateString) return null;
            const date = new Date(dateString);
            return date.toISOString();
        },

        async buscarPuntosEntrega() {
            if (!this.persona || !this.persona.empresa || !this.persona.empresa.id) {
                console.error("No se pudo obtener la información de la empresa");
                this.error = "Información de empresa no disponible";
                return;
            }

            this.loading = true;
            this.error = null;

            try {
                const fechaInicio = this.formatDateForBackend(this.filtros.fechaInicio);
                const fechaFin = this.formatDateForBackend(this.filtros.fechaFin);
                const empresaId = this.persona.empresa.id;

                console.log("Empresa ID:", empresaId);
                console.log("Fecha inicio:", fechaInicio);
                console.log("Fecha fin:", fechaFin);

                let url = `EntregasApp/GetPuntosEntregaYRemisiones?EmpresaId=${empresaId}&fechaInicio=${fechaInicio}`;
                if (fechaFin) {
                    url += `&fechaFin=${fechaFin}`;
                }

                console.log("URL completa:", url);

                let res = await this.$store.dispatch("hl_get", { path: url });
                console.log("Respuesta completa:", res);

                if (res.success) {
                    console.log("Datos recibidos:", res.data);

                    this.listaPuntosEntrega = res.data.map(item => ({
                        id: item.Id || item.id,
                        empresaId: item.EmpresaId || item.empresaId,

                        numeroDocumentoEntrega: item.NumeroDocumentoEntrega || item.numeroDocumentoEntrega,
                        descripcionPuntoEntrega: item.DescripcionPuntoEntrega || item.descripcionPuntoEntrega,
                        nombreCliente: item.NombreCliente || item.nombreCliente,
                        direccionPuntoEntrega: item.DireccionPuntoEntrega || item.direccionPuntoEntrega,
                        codigoSN: item.CodigoSN || item.codigoSN,
                        nombrePersonaCliente: item.NombrePersonaCliente || item.nombrePersonaCliente,
                        contactoPersonaCliente: item.ContactoPersonaCliente || item.contactoPersonaCliente,

                        distanciaRecorrida: item.DistanciaRecorrida || item.distanciaRecorrida,
                        tiempoRecorrido: item.TiempoRecorrido || item.tiempoRecorrido,
                        fechaHoraInicio: item.FechaHoraInicio || item.fechaHoraInicio,
                        fechaHoraEntrega: item.FechaHoraEntrega || item.fechaHoraEntrega,
                        fechaHoraFin: item.FechaHoraFin || item.fechaHoraFin,
                        tiempoDescarga: item.TiempoDescarga || item.tiempoDescarga,
                        estadoPuntoEntrega: item.EstadoPuntoEntrega || item.estadoPuntoEntrega,
                        plantillaRutasId: item.PlantillaRutasId || item.plantillaRutasId,
                        puntosEntregaGeneralesId: item.PuntosEntregaGeneralesId || item.puntosEntregaGeneralesId,
                        lugarEntrega: item.LugarEntrega || item.lugarEntrega,
                        latUbicacionEntrega: item.LatUbicacionEntrega || item.latUbicacionEntrega,
                        longUbicacionEntrega: item.LongUbicacionEntrega || item.longUbicacionEntrega,
                        fechaHoraInicioRuta: item.FechaHoraInicioRuta || item.fechaHoraInicioRuta,
                        nombreRuta: item.NombreRuta || item.nombreRuta,
                        descripcionRuta: item.DescripcionRuta || item.descripcionRuta,
                        placa: item.Placa || item.placa,
                        nombreCompleto: item.nombreCompleto || item.nombreCompleto,
                        distanciaTotalRecorrida: item.DistanciaTotalRecorrida || item.distanciaTotalRecorrida,
                        tiempoTotalRecorrido: item.TiempoTotalRecorrido || item.tiempoTotalRecorrido,
                        estadoRuta: item.EstadoRuta || item.estadoRuta,
                    }));

                    this.aplicarFiltros();
                } else {
                    console.warn("No se encontraron Puntos de Entrega");
                    this.listaPuntosEntrega = [];
                    this.listaPuntosEntregaFiltrados = [];
                    this.error = "No se encontraron datos para los criterios especificados";
                    this.actualizarPaginacion();
                }
            } catch (error) {
                console.error("Error al obtener los datos:", error);
                this.error = "Ocurrió un error al obtener los datos. Por favor, intente nuevamente.";
                this.listaPuntosEntrega = [];
                this.listaPuntosEntregaFiltrados = [];
                this.actualizarPaginacion();
            } finally {
                this.loading = false;
            }
        },

        aplicarBusqueda() {
            this.aplicarFiltros();
        },

        limpiarBusqueda() {
            this.filtros.busqueda = "";
            this.aplicarFiltros();
        },

        aplicarFiltrosAvanzados() {
            this.paginacion.paginaActual = 1;
            this.aplicarFiltros();
        },

        aplicarFiltros() {
            const busqueda = this.filtros.busqueda.toLowerCase().trim();
            const estadoPuntoEntrega = this.filtros.estadoPuntoEntrega;
            const estadoRuta = this.filtros.estadoRuta;
            const centroCosto = this.filtros.centroCosto.toLowerCase().trim();
            const cliente = this.filtros.cliente.toLowerCase().trim();

            // Aplicar todos los filtros
            const datosFiltrados = this.listaPuntosEntrega.filter(item => {
                // Filtro de búsqueda general
                const cumpleBusqueda = busqueda === "" ||
                    Object.values(item).some(val =>
                        val !== null &&
                        val !== undefined &&
                        val.toString().toLowerCase().includes(busqueda)
                    );

                // Filtros avanzados
                const cumpleEstadoPunto = estadoPuntoEntrega === "" ||
                    item.estadoPuntoEntrega === estadoPuntoEntrega;

                const cumpleEstadoRuta = estadoRuta === "" ||
                    item.estadoRuta === estadoRuta;

                const cumpleCentroCosto = centroCosto === "" ||
                    (item.lugarEntrega && item.lugarEntrega.toLowerCase().includes(centroCosto));

                const cumpleCliente = cliente === "" ||
                    (item.nombreCliente && item.nombreCliente.toLowerCase().includes(cliente));

                return cumpleBusqueda && cumpleEstadoPunto && cumpleEstadoRuta &&
                    cumpleCentroCosto && cumpleCliente;
            });

            // Actualizar datos filtrados y paginación
            this.paginacion.totalFiltrados = datosFiltrados.length;
            this.actualizarPaginacion();

            // Aplicar paginación
            const inicio = (this.paginacion.paginaActual - 1) * this.paginacion.registrosPorPagina;
            const fin = inicio + this.paginacion.registrosPorPagina;
            this.listaPuntosEntregaFiltrados = datosFiltrados.slice(inicio, fin);
        },

        actualizarPaginacion() {
            this.paginacion.totalPaginas = Math.ceil(this.paginacion.totalFiltrados / this.paginacion.registrosPorPagina) || 1;

            // Asegurarse de que la página actual no sea mayor que el total de páginas
            if (this.paginacion.paginaActual > this.paginacion.totalPaginas) {
                this.paginacion.paginaActual = this.paginacion.totalPaginas;
            }
        },

        cambiarPagina(pagina) {
            if (pagina < 1 || pagina > this.paginacion.totalPaginas) {
                return;
            }

            this.paginacion.paginaActual = pagina;
            this.aplicarFiltros();
        },

        cambiarRegistrosPorPagina() {
            this.paginacion.paginaActual = 1;
            this.aplicarFiltros();
        },

        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return 'Fecha no encontrada';

            const date = new Date(dateTimeStr);
            return date.toLocaleString('es-CO', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        getBadgeClass(estado) {
            switch (estado.toLowerCase()) {
                case 'no ha iniciado':
                case 'pendiente':
                    return 'badge-warning';
                case 'en proceso':
                case 'iniciada':
                    return 'badge-info';
                case 'completado':
                case 'finalizada':
                    return 'badge-success';
                case 'cancelado':
                    return 'badge-danger';
                default:
                    return 'badge-secondary';
            }
        },
    }
};
</script>

<style scoped>
.error-message {
    color: red;
    margin-top: 10px;
}

.modal-content {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 15px;
    padding: 30px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.modal-title {
    font-size: 1.8rem;
    margin-left: 15px;
    color: #2c3e50;
}

.route-details {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.detail-section {
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    padding: 15px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.section-title {
    color: #2c3e50;
    border-bottom: 2px solid #3498db;
    padding-bottom: 8px;
    margin-bottom: 15px;
}

.detail-item {
    background-color: rgba(255, 255, 255, 0.7);
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 15px;
    transition: all 0.3s ease;
}

.detail-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.detail-item p {
    margin-bottom: 5px;
}

.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.fadeIn {
    animation-name: fadeIn;
}

.emoji-container {
    font-size: 2.5rem;
    margin-bottom: 20px;
}

.animated-row {
    transition: background-color 0.3s ease;
}

.animated-row:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.form-group label {
    font-weight: 600;
    color: #2c3e50;
}

.form-control {
    border-radius: 0, 0, 0.05;
}

.form-group label {
    font-weight: 600;
    color: #2c3e50;
}

.form-control {
    border-radius: 8px;
    border: 1px solid #ddd;
    padding: 8px 12px;
    transition: all 0.3s ease;
}

.form-control:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 0.2rem rgba(52, 152, 219, 0.25);
}

.table-responsive {
    overflow-x: auto;
}

.badge {
    font-size: 0.85em;
    padding: 0.35em 0.65em;
}

.badge-warning {
    background-color: #ffc107;
    color: #212529;
}

.badge-info {
    background-color: #17a2b8;
    color: #fff;
}

.badge-success {
    background-color: #28a745;
    color: #fff;
}

.badge-danger {
    background-color: #dc3545;
    color: #fff;
}

.badge-secondary {
    background-color: #6c757d;
    color: #fff;
}

/* Estilos para la paginación */
.pagination {
    margin-bottom: 0;
}

.page-link {
    color: #3498db;
    background-color: #fff;
    border: 1px solid #dee2e6;
}

.page-link:hover {
    color: #216a94;
    background-color: #e9ecef;
    border-color: #dee2e6;
}

.page-item.active .page-link {
    background-color: #3498db;
    border-color: #3498db;
}

.page-item.disabled .page-link {
    color: #6c757d;
    background-color: #fff;
}

/* Transiciones */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>